var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geo-chart d-flex justify-content-center align-items-center",staticStyle:{"width":"100%","height":"500px"}},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"id":"myFrame","src":"/map/geoChart.html","width":"1366","height":"550","allowfullscreen":"","loading":"lazy","referrerpolicy":"no-referrer-when-downgrade"}})])
}]

export { render, staticRenderFns }